import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageFilterModalComponent } from './page-filter-modal.component';
import { FormsModule } from '@angular/forms';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FeFilterModalModule } from '../fe-filter-modal/fe-filter-modal.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [PageFilterModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    NzSelectModule,
    FeFilterModalModule,
    TranslateModule
  ]
})
export class PageFilterModalModule { }
